import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Amplify, { Analytics } from 'aws-amplify';
import { withAlert } from 'react-alert';
import isEmpty from 'lodash/isEmpty';
import * as _ from 'lodash';
import Dropdown from 'react-dropdown';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import MaskInputNumber from '../../common/maskInputNumberProfile';
import TextFieldGroup from '../../common/TextFieldGroupProfile';
import * as SecretKeys from '../../../ENV.json';
import { getBusinessSubUserById, getAllCountry, UpdateBusinessSubUser } from '../../../Actions/actions';
import SideMenu from '../../sideMenu/sideMenu';
import loader from '../../../images/Spin-1s-107px.gif';

Amplify.configure(SecretKeys.awsUserpool);

Analytics.disable();

class SubuserUpdateBusiness extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      firstname: '',
      lastname: '',
      title: '',
      phone: '',
      workPhone: '',
      password: '',
      countryCode: '+1',
      workCountryCode: '',
      businessSubUserId: '',
      cognitoClientId: '',
      errors: {},
      isLoading: false,
      failedLoginMessages: '',
      businessSubUserUpdatedData: '',
      state: false,
      isLoader: false,
      businessSubUserDataById1: [],
    };
    this.onChange = this.onChange.bind(this);
    this.handleSubUsers = this.handleSubUsers.bind(this);
    this._countrySelect = this._countrySelect.bind(this);
    this._countryWorkSelect = this._countryWorkSelect.bind(this);
    this.closeCompanyUserSub = this.closeCompanyUserSub.bind(this);
  }

  onChange(e) {
    this.setState({ errors: {}, isLoading: true, failedLoginMessages: '' });
    this.setState({ [e.target.name]: e.target.value });
  }

  closeCompanyUserSub() {
    this.context.router.history.push('/manageSubUsersBusiness');
  }

  _countrySelect(e) {
    this.setState({ countryCode: e.value });
  }

  _countryWorkSelect(e) {
    this.setState({ workCountryCode: e.value });
  }

  handleSubUsers(e) {
    e.preventDefault();
    if (this.isValid()) {
      this.setState({ state: true, errors: {}, isLoader: true });
      this.props.UpdateBusinessSubUser(this.state);
      // this.setState({
      //   email: '', firstname: '', lastname: '', phone: '', workPhone: '', password: '',
      // });
    }
  }

  isValid() {
    const { errors, isValid } = this.validateInput(this.state);
    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  validateInput(data) {
    const errors = {};
    if (!data.firstname) {
      errors.firstName = 'First name is Required';
      errors.firstNameError = true;
    } else if (data.firstname.length < 2 || data.firstname.length > 20) {
      errors.firstName = 'First name should be between 2 to 20 characters';
      errors.firstNameError = true;
    }
    if (!data.lastname) {
      errors.lastname = 'Last name is Required';
      errors.lastNameError = true;
    } else if (data.lastname.length < 2 || data.lastname.length > 20) {
      errors.lastname = 'Last name should be between 2 to 20 characters';
      errors.lastNameError = true;
    }

    if (!data.phone) {
      errors.phone = 'Mobile number is Required';
      errors.newMobilePhoneError = true;
    } else if (data.phone.replace(/\s/g, '').replace(/[_-]/g, '').length !== 10) {
      errors.phone = 'Please enter at least 10 digit';
      errors.newMobilePhoneError = true;
    }
    if (!data.workPhone) {
      errors.workPhone = 'Work Phone number is Required';
      errors.workPhoneError = true;
    } else if (data.workPhone.replace(/\s/g, '').replace(/[_-]/g, '').length !== 10) {
      errors.workPhone = 'Please enter at least 10 digit';
      errors.workPhoneError = true;
    }

    return {
      errors,
      isValid: isEmpty(errors),
    };
  }

  componentWillMount() {
    this.props.getBusinessSubUserById({ businessSubUserId: this.props.subUserId });
    this.props.getAllCountry();
  }

  componentDidUpdate() {
    const { businessSubUserUpdatedData, businessSubUserDataById } = this.props.data;
    const { businessSubUserUpdatedData1, businessSubUserDataById1 } = this.state;

    if (businessSubUserDataById !== undefined) {
      if (businessSubUserDataById1 !== businessSubUserDataById) {
        this.setState({
          email: businessSubUserDataById.email,
          firstname: businessSubUserDataById.firstName,
          lastname: businessSubUserDataById.lastName,
          phone: businessSubUserDataById.mobilePhone,
          countryCode: businessSubUserDataById.countryCode,
          title: businessSubUserDataById.companyTitle,
          workPhone: businessSubUserDataById.workPhoneNumber,
          workCountryCode: businessSubUserDataById.workCountryCode,
          businessSubUserId: businessSubUserDataById.businessSubUserId,
          cognitoClientId: businessSubUserDataById.cognitoClientId,
          businessSubUserDataById1: businessSubUserDataById,
          isLoader: false,
        });
      }
    }

    if (this.state.state === true) {
      if (businessSubUserUpdatedData.code !== undefined) {
        if (businessSubUserUpdatedData1 !== businessSubUserUpdatedData) {
          this.setState({
            businessSubUserUpdatedData1: businessSubUserUpdatedData,
            state: false,
            isLoader: false,
          });
          // toast.info('Sub user update successfully!', {
          //   position: toast.POSITION.TOP_CENTER,
          // });
          // setTimeout(() => {
          //   this.props.getBusinessSubUserById({ businessSubUserId: this.props.subUserId });
          // }, 2000);
        }
      }
    }
  }

  render() {
    const {
      errors, isLoader, firstname, lastname, phone, countryCode, title, workCountryCode, workPhone,
    } = this.state;
    const { AllCountryData } = this.props.data;
    const { isProfile }  =this.props;

    const optionsCountry = [];
    const optionsWorkCountry = [];
    if (AllCountryData !== undefined) {
      AllCountryData.map(item => optionsCountry.push({ value: item.countryCode, label: item.countryCode, name: item.countryCode }));
    } else {
      optionsCountry.push({ value: '+1', label: '+1', name: '+1' });
    }
    const cSelectedCountry = _.find(optionsCountry, { value: countryCode });
    const cDefaultOptionCountry = cSelectedCountry;

    if (AllCountryData !== undefined) {
      AllCountryData.map(item => optionsWorkCountry.push({ value: item.countryCode, label: item.countryCode, name: item.countryCode }));
    } else {
      optionsWorkCountry.push({ value: '+1', label: '+1', name: '+1' });
    }

    const dSelectedCountry = _.find(optionsWorkCountry, { value: workCountryCode });
    const dDefaultOptionWorkCountry = dSelectedCountry;
    let loader1;
    if (isLoader) {
      loader1 = (
        <div className="loader">
          <img src={loader} alt="" />
        </div>
      );
    }

    return (
      <span>
        {loader1}
        {/* <ToastContainer /> */}
        <SideMenu />
        <div>
{console.log("isProfile", isProfile)}
          <div className= {isProfile ? "main-content section-content add-sub-user" :"main-content section-content add-sub-user partner-referral"}>
            <div className="row">
              <div className="col s12 referral-hdr">
              {isProfile ? "" : (  <h4 className="col s12 m6">Update Sub User</h4>)}
                
                {isProfile ? "" : (
                <div
                  className="col s12 m6 grid-add-link"
                >
                  <button onClick={this.closeCompanyUserSub} type="submit" name="action" className="btn waves-effect waves-light primary-btn col s8 offset-s3 primary-btn-new sub-user-listing-button">
                    {' '}
                    <i className="material-icons">arrow_backward</i>
Sub User Listing
                  </button>

                </div>)}

              </div>


              <div className="col s12">
                <div className="welcome-partner add-welcomepartner">
                  <div className="col s12">

                    <form className="col s12" onSubmit={this.handleSubUsers}>
                      <div className="row">
                        <div className="input-field col s6">
                          <TextFieldGroup
                            field="firstname"
                            label="First Name*"
                            value={firstname || ''}
                            error={errors.firstName}
                            onChange={this.onChange}
                          />

                        </div>

                        <div className="input-field col s6">
                          <TextFieldGroup
                            field="lastname"
                            label="Last Name*"
                            value={lastname || ''}
                            error={errors.lastname}
                            onChange={this.onChange}
                          />

                        </div>

                        <div className="input-field col s6 clear">
                          <TextFieldGroup
                            field="title"
                            label="Title"
                            value={title || ''}
                            error={errors.title}
                            onChange={this.onChange}
                          />

                        </div>

                        <div className=" tel-input-outer input-field col s6">
                          <div className=" tel-input-lt">
                            <Dropdown
                              name="cState"
                              className="browser-default"
                              options={optionsCountry}
                              onChange={this._countrySelect}
                              value={cDefaultOptionCountry || ''}
                              placeholder="Select an option*"
                            />
                            <span className={errors.countryCodeError ? 'show invalid' : 'hide'}>{errors.countryCode}</span>
                          </div>

                          <div className=" tel-input-rt">
                            <MaskInputNumber
                              field="phone"
                              label="Phone Number*"
                              value={phone || ''}
                              error={errors.phone}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>

                        <div className=" tel-input-outer input-field col s6">
                          <div className=" tel-input-lt">
                            <Dropdown
                              name="sState"
                              className="browser-default"
                              options={optionsWorkCountry || ''}
                              onChange={this._countryWorkSelect}
                              value={dDefaultOptionWorkCountry}
                              placeholder="Select"
                            />
                            <span className={errors.workcountryCodeError ? 'show invalid' : 'hide'}>{errors.workCountryCode}</span>
                          </div>

                          <div className=" tel-input-rt">
                            <MaskInputNumber
                              field="workPhone"
                              label="Work Phone Number*"
                              value={workPhone || ''}
                              error={errors.workPhone}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>

                      </div>
                      <div className="row">
                        <div className="col s12 sav-sub-user-buttons">
                        {isProfile ? "" : (
                          <button onClick={this.closeCompanyUserSub} type="submit" name="action" className="btn waves-effect waves-light primary-btn col s8 offset-s3 primary-btn-new">
                            {' '}
Cancel
                            {' '}
                          </button> )}
                          <button type="submit" name="action" className="btn waves-effect waves-light primary-btn col s8 offset-s3 primary-btn-new">
{isProfile ? "Update" : "Update Sub User"}
                            {' '}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

SubuserUpdateBusiness.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getBusinessSubUserById, getAllCountry, UpdateBusinessSubUser }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(SubuserUpdateBusiness));
